/**
 * @generated SignedSource<<f733599997fda3093e9d7e97dc319ca5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "PENDING" | "DECLINED" | "INVOICED" | "%future added value";
export type useIsPersonWeekDeclined_Query$variables = {
  personId?: string | null;
  weekStart?: string | null;
  weekEnd?: string | null;
  windowStart?: string | null;
  windowEnd?: string | null;
  hasWindow: boolean;
};
export type useIsPersonWeekDeclined_Query$data = {
  readonly viewer: {
    readonly id: string;
    readonly component: string | null;
    readonly company: {
      readonly id: string;
      readonly useInternalTimeApproval: boolean | null;
      readonly person: {
        readonly id: string;
        readonly weekApprovals: ReadonlyArray<{
          readonly weekStartYear: number;
          readonly weekStartMonth: number;
          readonly weekStartDay: number;
          readonly approvalStatus: APPROVAL_STATUS;
        } | null> | null;
        readonly timeRegistrations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly year: number | null;
              readonly month: number | null;
              readonly day: number | null;
              readonly approvalStatus: APPROVAL_STATUS | null;
              readonly idleTime: {
                readonly id: string;
                readonly isInternalTime: boolean | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly windowApprovals?: ReadonlyArray<{
          readonly weekStartYear: number;
          readonly weekStartMonth: number;
          readonly weekStartDay: number;
          readonly approvalStatus: APPROVAL_STATUS;
        } | null> | null;
        readonly windowTimeRegistrations?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly year: number | null;
              readonly month: number | null;
              readonly day: number | null;
              readonly approvalStatus: APPROVAL_STATUS | null;
              readonly idleTime: {
                readonly id: string;
                readonly isInternalTime: boolean | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type useIsPersonWeekDeclined_Query = {
  variables: useIsPersonWeekDeclined_Query$variables;
  response: useIsPersonWeekDeclined_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasWindow"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekEnd"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekStart"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "windowEnd"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "windowStart"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "time_registration_modal_declined_week"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"time_registration_modal_declined_week\")"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useInternalTimeApproval",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "personId"
  }
],
v10 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "weekEnd"
},
v11 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "weekStart"
},
v12 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weekStartYear",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weekStartMonth",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weekStartDay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v17 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeRegTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "day",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IdleTime",
            "kind": "LinkedField",
            "name": "idleTime",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInternalTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": [
    (v10/*: any*/),
    (v18/*: any*/),
    (v11/*: any*/)
  ],
  "concreteType": "TimeRegTypeConnection",
  "kind": "LinkedField",
  "name": "timeRegistrations",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "windowEnd"
},
v22 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "windowStart"
},
v23 = [
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": "windowTimeRegistrations",
  "args": [
    (v21/*: any*/),
    (v18/*: any*/),
    (v22/*: any*/)
  ],
  "concreteType": "TimeRegTypeConnection",
  "kind": "LinkedField",
  "name": "timeRegistrations",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v25 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIsPersonWeekDeclined_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "PersonWeekApprovalType",
                    "kind": "LinkedField",
                    "name": "weekApprovals",
                    "plural": true,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "condition": "hasWindow",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "windowApprovals",
                        "args": (v23/*: any*/),
                        "concreteType": "PersonWeekApprovalType",
                        "kind": "LinkedField",
                        "name": "weekApprovals",
                        "plural": true,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIsPersonWeekDeclined_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "PersonWeekApprovalType",
                    "kind": "LinkedField",
                    "name": "weekApprovals",
                    "plural": true,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "condition": "hasWindow",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "windowApprovals",
                        "args": (v23/*: any*/),
                        "concreteType": "PersonWeekApprovalType",
                        "kind": "LinkedField",
                        "name": "weekApprovals",
                        "plural": true,
                        "selections": (v25/*: any*/),
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cffaa8c526e5011ba038c7e6e5c29ef",
    "id": null,
    "metadata": {},
    "name": "useIsPersonWeekDeclined_Query",
    "operationKind": "query",
    "text": "query useIsPersonWeekDeclined_Query(\n  $personId: ID\n  $weekStart: String\n  $weekEnd: String\n  $windowStart: String\n  $windowEnd: String\n  $hasWindow: Boolean!\n) {\n  viewer {\n    id\n    component(name: \"time_registration_modal_declined_week\")\n    company {\n      id\n      useInternalTimeApproval\n      person(id: $personId) {\n        id\n        weekApprovals(startDate: $weekStart, endDate: $weekEnd) {\n          weekStartYear\n          weekStartMonth\n          weekStartDay\n          approvalStatus\n          id\n        }\n        timeRegistrations(first: 10000, startDate: $weekStart, endDate: $weekEnd) {\n          edges {\n            node {\n              id\n              year\n              month\n              day\n              approvalStatus\n              idleTime {\n                id\n                isInternalTime\n              }\n            }\n          }\n        }\n        windowApprovals: weekApprovals(startDate: $windowStart, endDate: $windowEnd) @include(if: $hasWindow) {\n          weekStartYear\n          weekStartMonth\n          weekStartDay\n          approvalStatus\n          id\n        }\n        windowTimeRegistrations: timeRegistrations(first: 10000, startDate: $windowStart, endDate: $windowEnd) @include(if: $hasWindow) {\n          edges {\n            node {\n              id\n              year\n              month\n              day\n              approvalStatus\n              idleTime {\n                id\n                isInternalTime\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b044a2bef5a67ef0138dabcd5dc452c5";

export default node;
